import { createMutation } from '../api/mutation'

export const useConfigureApiKey = createMutation({
    url: '/configure-api-key',
    method: 'POST',
})

export const useUpdateOrg = createMutation({
    url: '/org',
    method: 'PATCH',
    keysToRefetch: [['/me'], ['/orgs']],
})

export const useCreateWorkspace = createMutation({
    url: '/org',
    method: 'POST',
})

export const useCreateBusiness = createMutation({
    url: '/business',
    method: 'POST',
})

export const useUpdateBusiness = createMutation({
    url: '/update-business',
    method: 'PATCH',
})

export const useDeleteWorkspace = (org_id: string) =>
    createMutation({
        url: `/workspace/${org_id}`,
        method: 'DELETE',
    })
